
import { defineComponent, inject, onUnmounted, ref } from 'vue'

export default defineComponent({
  name: 'RandselLoadingCircle',
  setup() {
    const visible = ref(true)
    const emitter: any = inject('emitter')

    emitter.on('startAnimation', hideLoading)

    function hideLoading() {
      visible.value = false
    }

    onUnmounted(() => {
      emitter.off('startAnimation', hideLoading)
    })

    return {
      visible
    }
  }
})
